import { render, staticRenderFns } from "./modern-slavery.vue?vue&type=template&id=49dcdc02&scoped=true&"
import script from "./modern-slavery.vue?vue&type=script&lang=js&"
export * from "./modern-slavery.vue?vue&type=script&lang=js&"
import style0 from "./modern-slavery.vue?vue&type=style&index=0&id=49dcdc02&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dcdc02",
  null
  
)

export default component.exports